import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';
import { StaticSitesDto } from '../../models/static-sites-dto';

export const STATIC_SITES_LIST_FETCH = 'STATIC_SITES_LIST_FETCH';
export const STATIC_SITES_LIST_RECEIVE = 'STATIC_SITES_LIST_RECEIVE';
export const STATIC_SITES_LIST_ERROR = 'STATIC_SITES_LIST_ERROR';

export const receiveStaticSitesList = (staticSites: PaginatedResponse<StaticSitesDto>) => {
    return {
        type: STATIC_SITES_LIST_RECEIVE,
        staticSites,
    };
};

const staticSitesListError = () => {
    return {
        type: STATIC_SITES_LIST_ERROR,
    };
};

export const fetchStaticSitesList = (searchParams: URLSearchParams) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: STATIC_SITES_LIST_FETCH });
        const response = await api.contentManagement.StaticSites.StaticSitesList.getStaticSites(searchParams);
        if (response.success) {
            dispatch(receiveStaticSitesList(response.result));
        } else {
            dispatch(staticSitesListError());
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
